export const phoneMask = ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

export function capitalizeFirstLetter(string) {
	return string[0].toUpperCase() + string.slice(1);
}

export const sliderSettings = {
	dots: false,
	infinite: true,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 4000,
	swipeToSlide: true,
	responsive: [
		{
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
			},
		},
	],
};

export const reviewsSliderSettings = {
	...sliderSettings,
	slidesToShow: 3,
	adaptiveHeight: false,
	responsive: [
		{
			breakpoint: 1200,
			settings: {
				slidesToShow: 2,
			},
		},
		{
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
			},
		},
	],
};

export const getMoneyString = (value: number, currencyPrefix = '$') => {
	return `${currencyPrefix}${value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`;
};
